// extracted by mini-css-extract-plugin
export default {"container":"table_container__boUdS","header":"table_header__ezVFd"};